<app-top-nav></app-top-nav>

<div class="main">
  <div style="flex-grow: 2">
    <div
      class="d-flex flex-column bg-light contentContainer"
      style="height: 100%; padding-top: 150px; padding-left: 8%"
    >
      <div class="pl-1 mb-5">
        <p i18n="@@admin.csv.triggercsv">Export</p>
      </div>

      <div class="d-flex flex-column justify-content">
        <div class="dropdown p-2">
          <button
            class="btn dropdown-toggle is-flex fit-content"
            type="button"
            id="dropdownMenu1"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ this.selectedCity || "city" }}
          </button>
          <div
            class="dropdown-menu fit-content dropdown-menu-1"
            aria-labelledby="dropdownMenu1"
          >
            <button
              class="dropdown-item"
              *ngFor="let city of cities"
              (click)="citySelected(city)"
              type="button"
            >
              {{ city }}
            </button>
          </div>
        </div>
        <div class="dropdown p-2">
          <button
            class="btn is-flex dropdown-toggle fit-content"
            type="button"
            id="dropdownMenu2"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ this.selectedFiberHood?.fiberHood || "fiberhood" }}
          </button>
          <div
            class="dropdown-menu fit-content dropdown-menu-2"
            aria-labelledby="dropdownMenu2"
          >
            <button
              class="dropdown-item"
              *ngFor="let fiberhood of fiberHoodList"
              (click)="fiberHoodSelected(fiberhood)"
            >
              {{ fiberhood.fiberHood }}
            </button>
          </div>
        </div>
        <div class="dropdown p-2">
          <button
            class="btn is-flex dropdown-toggle fit-content"
            type="button"
            id="dropdownMenu3"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ this.selectedBlock?.block || "block" }}
          </button>
          <div
            class="dropdown-menu fit-content dropdown-menu-3"
            aria-labelledby="dropdownMenu3"
          >
            <button
              class="dropdown-item"
              *ngFor="let block of blockList"
              (click)="blockSelected(block)"
            >
              {{ block.block }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="flex-grow: 1">
    <div
      class="
        d-flex
        flex-column
        bg-light
        contentContainer
        justify-content-between
      "
      style="
        height: 100%;
        padding-top: 25px;
        padding-bottom: 100px;
        padding-right: 8%;
      "
    >
      <div d-flex class="csv-buttons">
        <button
          class="trigger text-uppercase"
          *ngIf="canConfigureExportFields()"
          i18n="@@admin.csv.export.fields"
          (click)="openExportFieldsConfig()"
        >
          Export fields configuration
        </button>
      </div>
      <div d-flex class="csv-buttons" style="bottom: 150px">
        <button
          class="trigger text-uppercase mr-2"
          [ngClass]="{
            'button-inactive': !selectedFiberHood
          }"
          (click)="sendAreaIdForCsvTrigger()"
          i18n="@@admin.csv.trigger"
        >
          Full Export
        </button>
        <button
          class="trigger text-uppercase mr-6"
          [ngClass]="{
            'button-inactive': !selectedFiberHood
          }"
          (click)="sendAreaIdForCsvTriggerWithFilteredColumns()"
          i18n="@@admin.csv.trigger.custom"
        >
          Smart Export
        </button>
      </div>
    </div>
  </div>
</div>
